import { Injectable, inject } from '@angular/core';
import { StorageService } from '../../services/storage.service';

@Injectable({ providedIn: 'root' })
export abstract class GestArticoliBaseComponent {
  protected storeS = inject(StorageService);


  protected nomeModulo: string;



  amIVisible() {
    const permesso = this.storeS.permessiCorrente.find(p => p.nomeModulo == this.nomeModulo);
    return permesso != null;
  }

  amIWriteable() {
    const permesso = this.storeS.permessiCorrente.find(p => p.nomeModulo == this.nomeModulo);
    return (permesso != null && permesso.scrittura);
  }

  isModVisible(modulo : string) {
    const permesso = this.storeS.permessiCorrente.find(p => p.nomeModulo == modulo);
    return permesso != null;
  }

  isModWriteable(modulo : string) {
    const permesso = this.storeS.permessiCorrente.find(p => p.nomeModulo == modulo);
    return (permesso != null && permesso.scrittura);
  }


}
